import React from 'react'

import i18n from 'src/i18n'
import AddressDetails from './components/AddressDetails/AddressDetails'
import BillingDetails from './components/BillingDetails/BillingDetails'
import CartProducts from './components/CartProducts/CartProducts'

import { UserType } from 'src/redux/cart/types'
import { CartFormProps, CartPage } from './types'

export const getCartPages = ({ onNext, initialValues }: CartFormProps): CartPage[] => {
  const shouldRenderSender = initialValues.sender?.postalAddress?.postal_code

  const shoppingCartPage = {
    title: i18n.t('cartPages.shoppingCart'),
    component: <CartProducts onNext={onNext} />,
  }

  const senderDetailsPage = {
    title: i18n.t('cartPages.senderDetails'),
    component: <AddressDetails onNext={onNext} userType={UserType.Sender} key={UserType.Sender} />,
  }

  const receiverDetailsPage = {
    title: i18n.t('cartPages.receiverDetails'),
    component: (
      <AddressDetails onNext={onNext} userType={UserType.Receiver} key={UserType.Receiver} />
    ),
  }

  const billingDetailsPage = {
    title: i18n.t('cartPages.orderDetailsBilling'),
    component: <BillingDetails onNext={onNext} initialValues={initialValues} />,
  }

  return [
    shoppingCartPage,
    ...(shouldRenderSender ? [senderDetailsPage] : []),
    receiverDetailsPage,
    billingDetailsPage,
  ]
}
